import React from "react";
import { useSelector } from "react-redux";
import { BrowserRouter as Router } from "react-router-dom";
import PagesRoutes from "./PagesRoutes";

const PagesRouter = () => {
  const isAuthenticated = useSelector((state) => state.auth.isAuthenticated);
  return (
    <main>
      <Router>
        <PagesRoutes isAuthenticated={isAuthenticated} />
      </Router>
    </main>
  );
};

export default PagesRouter;
